/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminLoginRouteImport } from './routes/admin-login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminTabRouteImport } from './routes/admin.$tab'

const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/admin-login',
  path: '/admin-login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTabRoute = AdminTabRouteImport.update({
  id: '/$tab',
  path: '/$tab',
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/admin-login': typeof AdminLoginRoute
  '/admin/$tab': typeof AdminTabRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/admin-login': typeof AdminLoginRoute
  '/admin/$tab': typeof AdminTabRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/admin-login': typeof AdminLoginRoute
  '/admin/$tab': typeof AdminTabRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/admin' | '/admin-login' | '/admin/$tab'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/admin' | '/admin-login' | '/admin/$tab'
  id: '__root__' | '/' | '/admin' | '/admin-login' | '/admin/$tab'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AdminLoginRoute: typeof AdminLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/admin-login': {
      id: '/admin-login'
      path: '/admin-login'
      fullPath: '/admin-login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/$tab': {
      id: '/admin/$tab'
      path: '/$tab'
      fullPath: '/admin/$tab'
      preLoaderRoute: typeof AdminTabRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminTabRoute: typeof AdminTabRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminTabRoute: AdminTabRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AdminLoginRoute: AdminLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
